import { defineStore } from 'pinia'
import { cleanUpJSON } from '@/utils'
import axios from 'axios'
import For from './KQLSelects.js'

const api = '/api/cachedKQL'

export const useStore = defineStore('kirby', () => {
  const loading = ref(0)
  const site = ref({})
  const rawPage = ref({})
  const rawPages = ref({})

  const page = computed(() => rawPage.value)
  const pages = computed(() => rawPages.value)

  const uidsFromPath = (path = '') => {
    const parts = path.replace(/^\//, '').split('/').filter(Boolean)
    if (parts[0] === document.documentElement.lang) parts.shift()
    return parts.length ? parts : ['home']
  }

  const queryFromUIDs = (uids) => {
    let q = `page("${uids.shift()}")`
    while (uids.length) q += `.childrenAndDrafts.find("${uids.shift()}")`
    return q
  }

  const loadPageAndSite = (path = '', template) => {
    loading.value++
    const query = {
      select: {
        site: { query: 'site', select: For.For.Site },
        pages: { query: 'site.childrenAndDrafts', select: For.For.Children },
      }
    }
    axios.post(api, query).then(({ data }) => {
      loading.value--
      site.value = cleanUpJSON(data.result.site)
      rawPages.value = cleanUpJSON(data.result.pages)
    })
    loadPage(path, template)
  }

  const loadPage = (path = '', template) => {
    loading.value++
    const uids = uidsFromPath(path)
    const queryString = queryFromUIDs([...uids])
    const select = For.For[template] || For.For.Default
    const query = { select: { page: { query: queryString, select } } }
    axios.post(api, query).then(({ data }) => {
      loading.value--
      if (data.result.page) rawPage.value = cleanUpJSON(data.result.page)
    })
  }

  return { loading, site, pages, page, loadPageAndSite, loadPage }
})
